// import React, { useEffect, useState } from 'react'
// import { useIndexedDB } from '../../../context/IndexedContext'
// import Editor, { Toolbar } from 'react-simple-wysiwyg'

// const TreatmentRecords = ({
//   patientDiagnosis,
//   patientDBdata,
//   diagnosisName,
//   setPatientDBdata,
//   noteID,
// }) => {
//   const { getGeneralPlanStatement } = useIndexedDB()

//   const [treatmentText, setTreatmentText] = useState('')
//   const [hasTreatment, setHasTreatment] = useState(false)

//   useEffect(() => {
//     if (!diagnosisName) return

//     const savedFreeType =
//       patientDBdata?.currentNote?.data?.freeTypesEverything?.plans
//         ?.allTreatments?.[diagnosisName]

//     const loadTreatmentPlans = async () => {
//       const data = await getGeneralPlanStatement()
//       if (!data?.length) return

//       const matched = data.find(
//         (item) => item?.Data?.diagnosis?.label === diagnosisName
//       )

//       if (!matched) {
//         setHasTreatment(false)
//         return
//       }

//       const suggestionNames = matched.Data.accordions.flatMap(
//         (accordion) =>
//           accordion?.suggestions?.suggestionName?.map((s) => s.name) || []
//       )

//       if (suggestionNames.length === 0) {
//         setHasTreatment(false)
//         return
//       }

//       const generatedHtml = `
//         <div>
//           ${suggestionNames
//             .map((text) => `<div>${text}</div>`)
//             .join('')}
//         </div>
//       `

//       setTreatmentText(savedFreeType || generatedHtml)
//       setHasTreatment(true)
//     }

//     loadTreatmentPlans()
//   }, [diagnosisName, patientDiagnosis])

//   const handleBlur = () => {
//     if (!treatmentText.trim()) return

//     setPatientDBdata((prev) => ({
//       ...prev,
//       currentNote: {
//         ...prev.currentNote,
//         data: {
//           ...prev.currentNote.data,
//           freeTypesEverything: {
//             ...(prev.currentNote.data?.freeTypesEverything || {}),
//             plans: {
//               ...(prev.currentNote.data?.freeTypesEverything?.plans ||
//                 {}),
//               allTreatments: {
//                 ...(prev.currentNote.data?.freeTypesEverything?.plans
//                   ?.allTreatments || {}),
//                 [diagnosisName]: treatmentText,
//               },
//             },
//           },
//         },
//       },
//       allNotes: prev.allNotes?.map((note) => {
//         if (note.id !== noteID) return note

//         const parsedData = note.data ? JSON.parse(note.data) : {}

//         return {
//           ...note,
//           data: JSON.stringify({
//             ...parsedData,
//             freeTypesEverything: {
//               ...(parsedData.freeTypesEverything || {}),
//               plans: {
//                 ...(parsedData.freeTypesEverything?.plans || {}),
//                 allTreatments: {
//                   ...(parsedData.freeTypesEverything?.plans?.allTreatments || {}),
//                   [diagnosisName]: treatmentText,
//                 },
//               },
//             },
//           }),
//         }
//       }),
//     }))
//   }

//   if (!hasTreatment) return null

//   return (
//     <div className="w-100 my-4">
//       <div style={{ width: '30%' }}>Treatment Plan</div>
//       <Editor
//         value={treatmentText}
//         onChange={(e) => setTreatmentText(e.target.value)}
//         onBlur={handleBlur}
//         containerProps={{
//           style: {
//             width: '100%',
//             background: '#2D2D2D',
//             color: 'white',
//             border: 0,
//           },
//         }}
//       >
//         <Toolbar hidden />
//       </Editor>
//     </div>
//   )
// }

// export default TreatmentRecords

import React, { useEffect, useState } from 'react'
import { useIndexedDB } from '../../../context/IndexedContext'
import Editor, { Toolbar } from 'react-simple-wysiwyg'

const TreatmentRecords = ({
  patientDiagnosis,
  patientDBdata,
  diagnosisName,
  setPatientDBdata,
  noteID,
  hasTreatment, setHasTreatment
}) => {
  const { getGeneralPlanStatement } = useIndexedDB()

  const [treatmentText, setTreatmentText] = useState('')
  // const [hasTreatment, setHasTreatment] = useState(false)

  const savedFreeType =
    patientDBdata?.currentNote?.data?.freeTypesEverything?.plans
      ?.allTreatments?.[diagnosisName]

  useEffect(() => {
    if (!diagnosisName) return

    const loadTreatmentPlans = async () => {
      const data = await getGeneralPlanStatement()
      if (!data?.length) return

      const matched = data.find(
        item => item?.Data?.diagnosis?.label === diagnosisName
      )

      if (!matched) {
        setHasTreatment(false)
        return
      }

      const suggestionNames = matched.Data.accordions.flatMap(
        accordion =>
          accordion?.suggestions?.suggestionName?.map(s => s.name) || []
      )

      if (!suggestionNames.length) {
        setHasTreatment(false)
        return
      }

      const generatedHtml = `
        <div>
          ${suggestionNames.map(text => `<div>${text}</div>`).join('')}
        </div>
      `

      setTreatmentText(savedFreeType || generatedHtml)
      setHasTreatment(true)

      if (!savedFreeType) {
        setPatientDBdata(prev => ({
          ...prev,
          currentNote: {
            ...prev.currentNote,
            data: {
              ...prev.currentNote.data,
              freeTypesEverything: {
                ...(prev.currentNote.data?.freeTypesEverything || {}),
                plans: {
                  ...(prev.currentNote.data?.freeTypesEverything?.plans || {}),
                  allTreatments: {
                    ...(prev.currentNote.data?.freeTypesEverything?.plans
                      ?.allTreatments || {}),
                    [diagnosisName]: generatedHtml,
                  },
                },
              },
            },
          },
        }))
      }
    }

    loadTreatmentPlans()
  }, [diagnosisName, patientDiagnosis])

  const handleBlur = () => {
    if (!treatmentText.trim()) return

    setPatientDBdata(prev => ({
      ...prev,
      currentNote: {
        ...prev.currentNote,
        data: {
          ...prev.currentNote.data,
          freeTypesEverything: {
            ...(prev.currentNote.data?.freeTypesEverything || {}),
            plans: {
              ...(prev.currentNote.data?.freeTypesEverything?.plans || {}),
              allTreatments: {
                ...(prev.currentNote.data?.freeTypesEverything?.plans
                  ?.allTreatments || {}),
                [diagnosisName]: treatmentText,
              },
            },
          },
        },
      },
      allNotes: prev.allNotes?.map(note => {
        if (note.id !== noteID) return note

        const parsedData = note.data ? JSON.parse(note.data) : {}

        return {
          ...note,
          data: JSON.stringify({
            ...parsedData,
            freeTypesEverything: {
              ...(parsedData.freeTypesEverything || {}),
              plans: {
                ...(parsedData.freeTypesEverything?.plans || {}),
                allTreatments: {
                  ...(parsedData.freeTypesEverything?.plans?.allTreatments || {}),
                  [diagnosisName]: treatmentText,
                },
              },
            },
          }),
        }
      }),
    }))
  }

  if (!hasTreatment) return null

  return (
    <div className="w-100 my-4">
      <div style={{ width: '30%' }}>Treatment Plan</div>

      <Editor
        value={treatmentText}
        onChange={e => setTreatmentText(e.target.value)}
        onBlur={handleBlur}
        containerProps={{
          style: {
            width: '100%',
            background: '#2D2D2D',
            color: 'white',
            border: 0,
          },
        }}
      >
        <Toolbar hidden />
      </Editor>
    </div>
  )
}

export default TreatmentRecords
